import React from 'react';
import { Button } from 'react-bootstrap';
import { Node } from 'reducers/nodesReducer';

type TDisabledNodeRow = {
  node: Node;
  authorized: boolean;
  onEnable: () => void;
};

export default function DisabledNodeRow({ node, authorized, onEnable }: TDisabledNodeRow): React.ReactElement {
  return (
    <tr className="node-row disabled">
      <td>
        <strong title={node.aeTitle}>{node.aeTitle}</strong>
      </td>
      <td>{node.protocol}</td>
      <td>
        {node.protocol === 'DICOM' ? (
          <div title={`${node.aeTitle}@${node.ip}:${node.port}`}>{`${node.aeTitle}@${node.ip}:${node.port}`}</div>
        ) : (
          <div title={node.stowRsEndpoint}>{node.stowRsEndpoint}</div>
        )}
      </td>
      <td>
        {authorized && node.aeTitle !== 'SYS_PR0XY' && (
          <Button size="sm" onClick={onEnable}>
            enable
          </Button>
        )}
      </td>
    </tr>
  );
}
